module.exports = __webpack_public_path__ + "img/lowerabs-endo-mesomorph-female.b20830b9.svg";